import { useQuery } from '@tanstack/react-query'
import { UseBaseQueryOptions } from '@/core/api/type'
import { LineMessageLogQueryKey } from '../../constants'
import LineMessageLogService from '../services'
import { GetLineMessageLogGroupedResponse } from '../../types'

function useQueryGetLineMessageLogGrouped(
	logId: string,
	props?: UseBaseQueryOptions<GetLineMessageLogGroupedResponse>,
) {
	return useQuery({
		queryKey: [LineMessageLogQueryKey.GetLineMessageLogGrouped, logId],
		queryFn: () => LineMessageLogService.getLineMessageLogGrouped(logId),
		enabled: !!logId,
		...props,
	})
}

export default useQueryGetLineMessageLogGrouped
